"use strict";
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotificationType = void 0;
/**
 * 通知类型
 */
var NotificationType;
(function (NotificationType) {
    NotificationType["USER_MENTIONED"] = "userMentioned";
    NotificationType["USER_INVITED"] = "userInvited";
    NotificationType["GROUP_INVITED"] = "groupInvited";
    NotificationType["REMINDER"] = "reminder";
    NotificationType["COMMENTED"] = "commented";
    NotificationType["NORMAL"] = "normal";
    NotificationType["LIMIT_TIME_ACTIVITY"] = "limitTimeActivity";
    NotificationType["WECHAT_CLIP_ERROR"] = "wechatClipError";
    NotificationType["GIVE_SPACE_CAPACITY"] = "giveSpaceCapacity";
    NotificationType["PERSONAL_EXPIRATION"] = "personalExpiration";
    NotificationType["PERSONAL_EXPIRATION_BEFORE"] = "personalExpirationBefore";
    NotificationType["TEAM_EXPIRATION"] = "teamExpiration";
    NotificationType["TEAM_EXPIRATION_BEFORE"] = "teamExpirationBefore";
    NotificationType["UNIVERSAL"] = "universal";
    NotificationType["FORM_COMMIT"] = "formCommit";
    NotificationType["PAGE_SUBSCRIBE"] = "pageSubscribe";
    NotificationType["TEMPLATE"] = "template";
    NotificationType["COMMON_WITH_MOBILE_PUSH"] = "commonWithMobilePush";
    NotificationType["PUBLISH_PAGE"] = "publishPage";
})(NotificationType = exports.NotificationType || (exports.NotificationType = {}));
